<template>
  <div class="joinUs">
    <header-wrapper></header-wrapper>
    <!--    <header-wrapper></header-wrapper>-->
    <!-- <div class="banner">
      <p>伯乐寻才，职等你来</p>
    </div> -->
    <div class="post">
      <div class="contentTitle postTitle">
        <p class="name">
          <img src="../../assets/img/tit_left.png" alt="">
          加入我们
        </p>
        <p class="desc">JOB VACANCY</p>
      </div>
      <div class="postList animate__fadeInUp animate__animated">
        <ul>
          <li>
            <p>策划岗</p>
            <a href="https://m.zhipin.com/mpa/html/weijd/weijd-job/1a701f2c99e2aeee1HF40ty8EFpR?date8=20240617&sid=qr_self_jd&isAuthBack=1" target="_blank">了解更多</a>
          </li>
          <li>
            <p>设计岗</p>
            <a href="https://m.zhipin.com/mpa/html/weijd/weijd-job/ce6a51ffc1d09b2f1HB62Ny5FlVV?date8=20240617&sid=qr_self_jd" target="_blank">了解更多</a>
          </li>
          <!-- <li>
            <p>技术岗</p>
            <a href="https://m.zhipin.com/mpa/html/weijd/weijd-job/bf9e4393b9cbbcbb1Hd83di5FVZR?date8=20240617&sid=qr_self_jd" target="_blank">了解更多</a>
          </li> -->
          <li>
            <p>运营岗</p>
            <a href="https://m.zhipin.com/mpa/html/weijd/weijd-job/1b5e7d22621d24801HJ42Ni1GFpT?date8=20240617&sid=qr_self_jd" target="_blank">了解更多</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="welfare animate__animated animate__fadeInUp">
      <div class="contentTitle welfareTitle">
        <p class="name">
          <img src="../../assets/img/tit_left.png" alt="">
          员工福利
        </p>
        <p class="desc">EMPLOYEE WELFARE</p>
      </div>
      <div class="welfareContent">
        <div :class="[`w_item`]" v-for="(item,index) in welfreList" :key="index">
          <p class="p_text">{{ item.text1 }}</p>
          <p class="p_tit">{{ item.title }}</p>
          <img :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
    <footer-wrapper></footer-wrapper>
  </div>
</template>

<script>
import headerWrapper from '@/components/header'
import footerWrapper from '@/components/footer'

export default {
  name: 'JoinUs',
  components: { headerWrapper, footerWrapper },
  data() {
    return {
      welfreList:[
        {title:"节庆关怀",imgUrl:require("@/assets/img/welfareContent/welfare1.png"),text1:"丰富的节日礼品 有趣的节日创意活动"},
        {title:"营养两餐",imgUrl:require("@/assets/img/welfareContent/welfare2.png"),text1:"自助营养午餐、晚餐"},
        {title:"下午茶",imgUrl:require("@/assets/img/welfareContent/welfare3.png"),text1:"每周丰盛下午茶"},
        {title:"1对1导师培养体系",imgUrl:require("@/assets/img/welfareContent/welfare4.png"),text1:"1对1导师指导 入职小指南"},
        {title:"花样社团",imgUrl:require("@/assets/img/welfareContent/welfare5.png"),text1:"篮球、羽毛球、游泳健身等 花样社团每周开展活动"},
        {title:"旅游团建",imgUrl:require("@/assets/img/welfareContent/welfare6.png"),text1:"定期团队建设 公司旅游周年庆/年会活动"},
        {title:"打车报销",imgUrl:require("@/assets/img/welfareContent/welfare7.png"),text1:"滴滴/高德企业打车 免除报销繁琐"},
        {title:"学习培训",imgUrl:require("@/assets/img/welfareContent/welfare8.png"),text1:"内部培训分享 外出学习交流"},
        {title:"带薪假期",imgUrl:require("@/assets/img/welfareContent/welfare9.png"),text1:"法定节假日/ 年假/病假/婚假/产假陪产假"},
        {title:"员工关爱",imgUrl:require("@/assets/img/welfareContent/welfare10.png"),text1:"结婚礼金，生育礼物"},
        {title:"社会保险",imgUrl:require("@/assets/img/welfareContent/welfare11.png"),text1:"社保六险 入职即购买"},
        {title:"住房公积金",imgUrl:require("@/assets/img/welfareContent/welfare12.png"),text1:"住房公积金 入职即购买"},
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.joinUs{
  background: #f3f4f6;
  // .banner{
  //   background:url("../../assets/img/joinUsBanner.png") no-repeat;
  //   background-size: cover;
  //   background-position: center;
  //   width: 100%;
  //   height: 196px;
  //   padding-top: 88px;
  //   p{
  //     font-size: 96px;
  //     //font-family: Microsoft YaHei;
  //     font-weight: 400;
  //     color: #FFFFFF;
  //     text-align: center;
  //   }
  // }
  .contentTitle{
    text-align: left;
    margin-left: 15%;
    .desc{
      font-size: 24px;
      color: #687088;
    }
  }
  .post{
    // height: 1000px;
    .postTitle{
      padding: 40px 0;
    }
    .postList{
      width: 1585px;
      margin: 0px auto 0 ;
      ul{
        li{
          width: 459px;
          height: 298px;
          background: #FFFFFF;
          border-radius: 24px;
          text-align: center;
          margin-bottom: 58px;
          margin-right: 102px;
          display: inline-block;
          &:last-child{
            margin-right: 0px;
          }
          &:nth-child(3){
            margin-right: 0px;
          }
          p{
            font-size: 48px;
            //font-family: 'Microsoft YaHei';
            font-weight: 400;
            color: #333333;
            margin-bottom: 36px;
            padding-top: 86px;
          }
          a {
            width: 240px;
            height: 48px;
            line-height: 48px;
            background: #F56057;
            border-radius: 24px;
            font-size: 18px;
            //font-family: 'Microsoft YaHei';
            font-weight: 400;
            color: #FFFFFF;
            display: inline-block;
            text-align: center;
            transition: all .5s ease;
            &:hover{
              background: #fca6a1;
            }
          }
        }
      }
    }
  }
  .welfare{
    height: 1528px;
    background: #FFFFFF;
    margin-bottom: 150px;
    .welfareTitle{
      // padding-top: 50px;
    }
    .welfareContent{
      width: 1462px;
      margin:62px auto 0 auto;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .w_item{
        text-align: center;
        width: 25%;
        margin: 30px auto 50px;
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        img{
          width: 170px;
          height: auto;
        }
        .p_tit{
          font-size: 36px;
          margin: 25px 0;
        }
      }
    }
  }
}

</style>